import { render, staticRenderFns } from "./MyFee.vue?vue&type=template&id=73b53749&scoped=true&"
import script from "./MyFee.vue?vue&type=script&lang=js&"
export * from "./MyFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b53749",
  null
  
)

export default component.exports